import { MarkdownASTToDeltaExtension } from '@blocksuite/affine-shared/adapters';

// 防止视频链接被当作普通超链处理，留给视频 matcher 处理
const videoUrlRegex =
  /https?:\/\/[^\s"']+\.(?:mp4|webm|ogg|mov|m4v|flv|mkv|avi|wmv|3gp)(?:\?[^"'\\s]*)?/i;

export const markdownLinkToDeltaMatcher = MarkdownASTToDeltaExtension({
  name: 'link',
  match: ast =>
    ast.type === 'link' &&
    // 如果是视频链接，交由视频 matcher 处理
    !(typeof (ast as any).url === 'string' && videoUrlRegex.test((ast as any).url)),
  toDelta: (ast, context) => {
    if (!('children' in ast) || !('url' in ast)) {
      return [];
    }
    const rawUrl = ast.url || '';
    const inTable = Boolean((context.options as any)?.inTable);
    // 表格内的视频链接优先转为 inline video，避免被当作超链
    if (inTable && videoUrlRegex.test(rawUrl)) {
      const imageProxy = context.configs.get('imageProxy');
      const proxiedUrl =
        imageProxy &&
          /^https?:\/\//i.test(rawUrl) &&
          !rawUrl.startsWith(imageProxy)
          ? `${imageProxy}${rawUrl}`
          : rawUrl;
      return [
        {
          insert: ' ',
          attributes: {
            video: {
              src: proxiedUrl,
              alt:
                Array.isArray(ast.children) && ast.children.length > 0
                  ? ((ast.children[0] as any).value as string) || ''
                  : '',
              title: undefined,
            },
          },
        },
      ];
    }
    const { configs } = context;
    const baseUrl = configs.get('docLinkBaseUrl') ?? '';
    if (baseUrl && ast.url.startsWith(baseUrl)) {
      const path = ast.url.substring(baseUrl.length);
      //    ^ - /{pageId}?mode={mode}&blockIds={blockIds}&elementIds={elementIds}
      const match = path.match(/^\/([^?]+)(\?.*)?$/);
      if (match) {
        const pageId = match?.[1];
        const search = match?.[2];
        const searchParams = search ? new URLSearchParams(search) : undefined;
        const mode = searchParams?.get('mode');
        const blockIds = searchParams?.get('blockIds')?.split(',');
        const elementIds = searchParams?.get('elementIds')?.split(',');

        return [
          {
            insert: ' ',
            attributes: {
              reference: {
                type: 'LinkedPage',
                pageId,
                params: {
                  mode:
                    mode && ['edgeless', 'page'].includes(mode)
                      ? (mode as 'edgeless' | 'page')
                      : undefined,
                  blockIds,
                  elementIds,
                },
              },
            },
          },
        ];
      }
    }
    return ast.children.flatMap(child =>
      context.toDelta(child).map(delta => {
        delta.attributes = { ...delta.attributes, link: ast.url };
        return delta;
      })
    );
  },
});
